export default {
  eventsPortal: {
    pageTitle: "Мероприятия",
    pageSubtitle: "Управляйте вашими мероприятиями и процессами модерации в одном месте.",
    pageSubtitleParticipant: "Находите и регистрируйтесь на мероприятия.",
    sidebarTitle: "Навигация",
    sidebarSubtitle: "Быстрый доступ к разделам",
    navModerationSection: "Модерация",
    catalogNavGroupLabel: "Каталог",
    badge: "Мероприятия",
    welcome: {
      greeting: "Здравствуйте, {{name}}",
      hint: "Управляйте своими событиями, модерацией и регистрациями участников.",
      hintParticipant: "Находите интересные события и регистрируйтесь на мероприятия.",
    },
    sidebarAria: "Разделы мероприятий",
    navAria: "Навигация по мероприятиям",
    logout: "Выйти",
    sectionSubtitle: "Раздел мероприятий",
    refresh: "Обновить",
    retry: "Повторить запрос",
    loading: "Загружаем мероприятия...",
    loadError: "Не удалось загрузить данные. Попробуйте позже.",
    actionError: "Не удалось выполнить действие. Попробуйте снова.",
    participantsLoadError: "Не удалось загрузить заявки участников.",
    inDevelopmentTitle: "Раздел в разработке",
    inDevelopmentBody: "Скоро здесь появится полный функционал для выбранного раздела.",
    backToEvents: "Ко всем мероприятиям",
    tabs: {
      overview: "Обзор",
      all: "Все",
      created: "Мои мероприятия",
      moderation: "Модерация мероприятий",
      registrations: "Модерация регистраций",
      attendance: "Посещение мероприятий",
    },
    overview: {
      title: "Обзор",
      subtitle: "Выберите раздел для дальнейшей работы с мероприятиями.",
      subtitleParticipant: "Сводка по вашим заявкам и доступным мероприятиям.",
      createdHint: "Мероприятия, которыми вы управляете как организатор",
      noSections: "Нет доступных разделов обзора для вашей учётной записи.",
      moderationHint: "Проверка и публикация мероприятий",
      registrationsHint: "Проверка и управление заявками участников",
      statsLoading: "Загружаем сводку…",
      statsTitle: "Сводка",
      statsLoadError: "Не удалось загрузить сводку. Попробуйте позже.",
      totalCreated: "Мои мероприятия: {{count}}",
      createdMetricsTitle: "По статусам",
      createdMetricsExtraTitle: "Работа с заявками",
      createdMetrics: {
        pendingRegistrations: "Заявок на рассмотрении",
        openFiltered: "Открыть раздел: {{label}}, {{count}}",
      },
      createdChipExpand: "{{label}}. Развернуть статистику мероприятий",
      createdChipCollapse: "{{label}}. Свернуть статистику мероприятий",
      moderationQueue: "В очереди на модерацию: {{count}}",
      moderationChipLabel: "Модерация: {{count}}",
      moderationChipExpand: "{{label}}. Развернуть статистику модерации",
      moderationChipCollapse: "{{label}}. Свернуть статистику модерации",
      moderationMetricsTitle: "По разделам",
      moderationMetrics: {
        events: "Мероприятия на модерации",
        registrations: "Заявок на рассмотрении",
        openSection: "Перейти в раздел: {{label}}, {{count}}",
      },
      registrationEvents: "Мероприятий для работы с заявками: {{count}}",
      pendingRegistrationsReview: "Заявок на рассмотрении: {{count}}",
      goToSection: "Перейти в раздел",
      visitsTitle: "Мои посещения",
      visitsHint: "Мероприятия, на которые вы подали заявку",
      visitsChipLabel: "Мои посещения: {{count}}",
      visitsChipExpand: "{{label}}. Развернуть статистику посещений",
      visitsChipCollapse: "{{label}}. Свернуть статистику посещений",
      visitsAppliedTotal: "Подали заявку: {{count}}",
      visitsMetricsTitle: "По заявкам",
      visitsMetrics: {
        applied: "Подали заявку",
        confirmed: "Согласовано",
        rejected: "Отклонено",
        visited: "Посетили",
        pending: "Ожидает подтверждения",
      },
      visitsEventsModal: {
        titleApplied: "Мероприятия с поданной заявкой",
        titleConfirmed: "Мероприятия с согласованной заявкой",
        titleRejected: "Мероприятия с отклонённой заявкой",
        titleVisited: "Посещённые мероприятия",
        titlePending: "Ожидают подтверждения заявки",
        empty: "Нет мероприятий в этой категории.",
        close: "Закрыть",
        openList: "Открыть список: {{label}}, {{count}}",
      },
    },
    registrationCard: {
      registered: "Зарегистрировано: {{count}}",
      pending: "Ожидают подтверждения: {{count}}",
      countsLoading: "Загружаем число заявок…",
      countsUnavailable: "Не удалось загрузить счётчики заявок.",
    },
    emptyFilters: "Нет мероприятий с выбранными фильтрами. Измените фильтры или сбросьте направления.",
    empty: {
      all: "Ничего не найдено",
      created: "Не найдено мероприятий, где вы указаны организатором.",
      moderation: "Нет мероприятий в статусе модерации.",
      registrations: "Нет опубликованных мероприятий для работы с регистрациями.",
    },
    actions: {
      approve: "Подтвердить",
      reject: "Отклонить",
      cancelEvent: "Отменить мероприятие",
      deleteEvent: "Удалить мероприятие",
      editEvent: "Редактировать",
      duplicateEvent: "Копировать",
      submitForModeration: "На модерацию",
      notAvailable: "Действие недоступно для текущего статуса мероприятия",
    },
    actionsHint: {
      cancelInvalidEndTime: "Не удалось определить время окончания. Проверьте даты мероприятия",
      cancelEndTimePassed: "Отменить нельзя: время окончания уже прошло",
      cancelAvailable: "Можно отменить мероприятие",
      cancelUnavailable: "Отмена недоступна для текущего статуса",
      deleteAvailable: "Можно удалить мероприятие",
      deleteUnavailable: "Удаление недоступно для текущего статуса",
    },
    participants: {
      sectionTitle: "Участники и заявки",
      pendingTitle: "Ожидают подтверждения",
      otherTitle: "Все участники",
      pendingEmpty: "Нет заявок в ожидании.",
      otherEmpty: "Пока нет подтверждённых или отменённых заявок.",
      totalCount: "Всего заявок: {{count}}",
      registeredAt: "Подана: {{date}}",
      toggleAnswers: "Ответы на вопросы",
      answerFallback: "Ответ",
      loadMore: "Показать ещё",
      approveRegistrationAria: "Подтвердить заявку участника {{name}}",
      rejectRegistrationAria: "Отклонить заявку участника {{name}}",
      booleanYes: "Да",
      booleanNo: "Нет",
      viewProfile: "Карточка участника",
      viewProfileAria: "Открыть карточку участника: профиль и ответы на вопросы мероприятия",
      markVisited: "Отметить посещение",
      markVisitedAria: "Отметить посещение участника {{name}}",
      undoCheckIn: "Снять отметку",
      undoCheckInAria: "Снять отметку посещения участника {{name}}",
      searchLabel: "Поиск",
      searchPlaceholder: "Имя или email участника",
      statusFilterLabel: "Статус",
      statusFilter: {
        all: "Все",
        confirmed: "Подтвержденные",
        visited: "Посетили",
      },
    },
    attendance: {
      title: "Посещение мероприятий",
      subtitle:
        "Отмечайте только тех, кто пришёл на мероприятие. Если участник не пришёл — отметку не проставляйте.",
      selectEventHint: "Выберите мероприятие в списке слева, чтобы отметить посещение участников.",
      eventSearchPlaceholder: "Поиск по названию или месту…",
      eventListAria: "Список мероприятий для отметки посещения",
      selectEvent: "Выберите мероприятие",
      eventCount: "Мероприятий: {{count}}",
      viewEvent: "Посмотреть мероприятие",
      viewEventAria: "Посмотреть карточку мероприятия «{{title}}»",
      openEvent: "Открыть карточку мероприятия",
      summaryAria: "Сводка по статусам участников",
      summaryConfirmed: "Подтверждены: {{count}}",
      summaryVisited: "Посетили: {{count}}",
      summaryTotal: "Всего: {{count}}",
      participantColumn: "Участник",
      emailColumn: "Email",
      statusColumn: "Статус",
      actionsColumn: "Действия",
      participantsListAria: "Список участников мероприятия",
      noEvents: "Нет опубликованных мероприятий, где вы можете отмечать посещение.",
      eventLoadError: "Не удалось загрузить мероприятие.",
      participantsEmpty: "Нет участников с выбранными фильтрами.",
    },
    undoCheckInModal: {
      title: "Снять отметку посещения?",
      message:
        "Участник {{name}} вернётся к статусу до отметки на входе. Отметка посещения будет удалена.",
      cancel: "Отмена",
      confirm: "Снять отметку",
    },
    participantProfile: {
      title: "Профиль участника",
      modalKicker: "Кабинет",
      back: "Назад к мероприятию",
      backAria: "Вернуться к предыдущему экрану",
      loadError: "Не удалось загрузить профиль.",
      forbidden: "Нет доступа к этому профилю.",
      notFound: "Профиль не найден.",
      createdAt: "Дата создания учётной записи",
      email: "Email",
      phone: "Телефон",
      birthDate: "Дата рождения",
      bio: "О себе",
      genderOther: "Другой",
      pointsLevel: "Баллы и уровень",
      inn: "ИНН",
      snils: "СНИЛС",
      sectionEducation: "Образование",
      sectionWork: "Опыт работы",
      sectionLanguages: "Языки",
      sectionPortfolio: "Портфолио",
      sectionAccounts: "Аккаунты",
      sectionExtra: "Дополнительно",
      sectionResponseExtensions: "Расширения ответа API",
      educationLookupInstitution: "Учреждение из справочника: {{name}}",
      yearsShort: "{{count}} лет опыта",
      tabProfile: "Профиль",
      tabRegistrationAnswers: "Ответы на вопросы",
      registrationLoading: "Загрузка ответов…",
      registrationNotFound: "Заявка этого участника на мероприятие не найдена в списке.",
      registrationNoAnswers: "В заявке нет ответов на вопросы анкеты.",
      registrationLoadError: "Не удалось загрузить ответы на вопросы.",
    },
    filters: {
      searchPlaceholder: "Поиск по названию или описанию",
      statusAll: "Все",
      statusRegistrationOpen: "Открыта регистрация",
      statusFilterAria: "Фильтр статуса: {{status}}",
      sortNewest: "Сначала новые",
      sortUpcoming: "Сначала ближайшие",
      sortTitle: "По названию (А-Я)",
      sortMenuAria: "Сортировка: {{label}}",
    },
    catalog: {
      openEventDetailsAria: "Открыть карточку мероприятия «{{title}}»",
    },
    badges: {
      registration: "Регистрация",
      start: "Начало мероприятия",
    },
    rejectModal: {
      title: "Отклонение мероприятия",
      reasonLabel: "Причина отклонения",
      reasonPlaceholder: "Укажите причину отклонения мероприятия",
      cancel: "Отмена",
      confirm: "Отклонить",
    },
    rejectRegistrationModal: {
      title: "Отклонить заявку участника?",
      cancel: "Отмена",
      confirm: "Отклонить заявку",
    },
    cancelEventModal: {
      title: "Отменить мероприятие?",
      cancel: "Отмена",
      confirm: "Отменить мероприятие",
    },
    deleteEventModal: {
      title: "Удалить мероприятие?",
      cancel: "Отмена",
      confirm: "Удалить",
    },
    withdrawEventModal: {
      title: "Отозвать мероприятие с модерации?",
      cancel: "Отмена",
      confirm: "Отозвать",
    },
    export: {
      title: "Экспорт в Excel",
      toolbarButton: "Экспорт в Excel",
      toolbarAria: "Открыть настройки экспорта мероприятия в Excel",
      close: "Закрыть",
      cancel: "Отмена",
      download: "Скачать",
      loadingCatalog: "Загружаем поля для экспорта…",
      catalogLoadError: "Не удалось загрузить список полей. Попробуйте снова.",
      downloadError: "Не удалось скачать файл. Попробуйте снова.",
      noSheetsSelected: "Выберите хотя бы один лист для экспорта.",
      sheetsTitle: "Листы",
      sheetEvent: "Мероприятие",
      sheetParticipants: "Участники",
      sheetApplications: "Заявки",
      eventFieldsTitle: "Поля мероприятия",
      registrationFieldsTitle: "Поля участников и заявок",
      questionAnswers: "Ответы на вопросы анкеты",
      questionAnswersHint: "Отдельная колонка на каждый вопрос анкеты мероприятия.",
      selectAll: "Выбрать все",
      clearAll: "Снять все",
      ungrouped: "Прочее",
    },
    preview: {
      moderationRejectionTitle: "Причина отклонения модератором",
      title: "Предпросмотр мероприятия",
      back: "Назад к списку",
      questionsTitle: "Вопросы при регистрации",
      questionsEmpty: "Вопросы при регистрации не добавлены.",
      questionType: "Тип",
      publicViewLink: "Как видят участники",
      loadError: "Не удалось загрузить мероприятие.",
      forbidden: "Нет доступа к этому мероприятию.",
      notFound: "Мероприятие не найдено.",
      withdrawFromModeration: "Отозвать с модерации",
      staffPermissionsNone: "Права не назначены",
    },
    registrationStatus: {
      "-1": "Открыта",
      0: "Зарегистрирован",
      1: "Посетил",
      2: "Check-out",
      3: "Отменена",
      4: "Ожидает подтверждения",
      5: "Подтверждена",
      6: "Отклонена",
    },
    create: {
      open: "Создать мероприятие",
      title: "Создание мероприятия",
      editTitle: "Редактирование мероприятия",
      duplicateTitle: "Копирование мероприятия",
      close: "Закрыть",
      cancel: "Отмена",
      submit: "Создать",
      update: "Сохранить изменения",
      saveDraft: "Сохранить",
      publish: "Опубликовать",
      publishPromptTitle: "Хотите опубликовать мероприятие?",
      publishPromptYes: "Опубликовать",
      publishPromptNo: "Сохранить в черновик",
      saving: "Создаем...",
      updating: "Сохраняем...",
      error: "Не удалось создать мероприятие",
      duplicateError: "Не удалось создать копию мероприятия",
      updateError: "Не удалось обновить мероприятие",
      selectedImages: "Выбрано изображений: {{count}}",
      imageSlotsListAria: "Изображения мероприятия",
      openImagePreviewAria: "Открыть просмотр, изображение {{index}}",
      removeImageAria: "Удалить изображение",
      coverBadge: "Обложка",
      setCover: "На обложку",
      noImagesYet: "Добавьте изображения кнопкой выше.",
      coverPreviewTitle: "Предпросмотр обложки",
      coverPreviewDescription: "Так изображение будет выглядеть на карточках и странице мероприятия.",
      coverPreviewHint: "Рекомендуем горизонтальное изображение 16:9, важные детали держите ближе к центру.",
      lightboxTitle: "Просмотр изображения",
      lightboxPrev: "Предыдущее изображение",
      lightboxNext: "Следующее изображение",
      lightboxClose: "Закрыть",
      questionsTitle: "Вопросы регистрации",
      addQuestion: "Добавить вопрос",
      removeQuestion: "Удалить вопрос",
      fields: {
        title: "Название",
        description: "Описание",
        location: "Место проведения",
        city: "Город проведения",
        citySearch: "Поиск города",
        startTime: "Начало мероприятия",
        endTime: "Окончание мероприятия",
        registrationStartTime: "Начало регистрации",
        registrationEndTime: "Окончание регистрации",
        date: "Дата",
        time: "Время",
        images: "Изображения",
        chooseImages: "Выбрать файлы",
        isPublic: "Публичное мероприятие",
        isPublicDescription:
          "Регистрация участников не требует подтверждения модератором: заявки принимаются автоматически.",
        questionTitle: "Текст вопроса",
        required: "Обязательный вопрос",
        optionsHint: "Введите вариант ответа",
        addOption: "Добавить вариант",
        optionPlaceholder: "Вариант ответа",
        removeOption: "Удалить",
        optionsEmpty: "Пока нет вариантов ответа",
        organizerLastName: "Фамилия организатора",
        organizerFirstName: "Имя организатора",
        organizerEmail: "Email организатора",
        organizerPhone: "Телефон организатора",
        direction: "Направление",
        directionPlaceholder: "Выберите направление",
      },
      organizerSection: "Контакты организатора",
      socialSection: "Ссылки на соцсети",
      socialVk: "ВКонтакте",
      socialTelegram: "Telegram",
      socialRemove: "Убрать",
      socialAddVk: "Добавить ВКонтакте",
      socialAddTelegram: "Добавить Telegram",
      questionTypes: {
        single: "Одиночный выбор",
        multi: "Множественный выбор",
        text: "Текст",
        number: "Число",
        bool: "Да/Нет",
      },
      staff: {
        title: "Сотрудники мероприятия",
        hint: "Назначьте помощников: модерация заявок на участие и отметка прихода или ухода участников.",
        searchLabel: "Поиск пользователя",
        searchPlaceholder: "Не менее 2 символов: имя, логин или email",
        empty: "Пока не добавлен ни один сотрудник.",
        remove: "Убрать",
        canModerateRegistrations: "Модерация заявок",
        canCheckIn: "Отметка прихода (check-in)",
        canCheckOut: "Отметка ухода (check-out)",
      },
      validation: {
        required: "Заполните обязательные поля",
        endAfterStart: "Дата окончания должна быть позже даты начала",
        registrationRange: "Окончание регистрации должно быть позже начала регистрации",
        organizerRequired: "Укажите имя, фамилию, email и телефон организатора",
        imagesRequired: "Добавьте хотя бы одно изображение мероприятия",
        choiceOptionsMin:
          "Для вопросов с одиночным или множественным выбором укажите не менее двух вариантов ответа",
        socialUrlHttp: "Ссылка на соцсеть должна начинаться с http:// или https://",
        industryRequired: "Выберите направление мероприятия",
      },
    },
  },
  eventsPage: {
    kicker: "Афиша",
    title: "Мероприятия",
    subtitle:
      "Лекции, выставки, мастер-классы и другие события экосистемы Ленинка IP для авторов, исследователей и креативных команд",
    registerCta: "Зарегистрироваться",
    open: "Открыть",
    rowOpen: "Открыть мероприятие: {{title}}",
    loadError: "Не удалось загрузить мероприятия. Попробуйте позже.",
    loadMoreError: "Не удалось подгрузить ещё мероприятия.",
    homeExploreTitle: "Открыть полную афишу",
    homeExploreHint: "Лекции, выставки, мастер-классы — найдите событие для себя",
    homeExploreCount: "{{count}} событий в каталоге",
    homeExploreAria: "Перейти ко всем мероприятиям",
    empty: "Ничего не найдено",
    emptyFilters: "Нет мероприятий с выбранными фильтрами среди уже загруженных. Сбросьте фильтры на «Все» или пролистайте дальше.",
    filters: {
      scheduleAll: "Все",
      scheduleStartHeading: "Начало мероприятия",
      scheduleStartAria: "Фильтр по началу мероприятия: скоро, идёт сейчас или завершено",
      registrationAll: "Все",
      registrationHeading: "Регистрация",
      registrationAria: "Фильтр по статусу регистрации: скоро, открыта или закрыта",
      registrationSoon: "Скоро",
      registrationOpen: "Открыта",
      registrationClosed: "Закрыта",
      chipPrefixStart: "Начало:",
      chipPrefixRegistration: "Регистрация:",
      chipsGroupScheduleAria: "Фильтры по началу мероприятия",
      chipsGroupRegistrationAria: "Фильтры по регистрации",
      comboButtonDefault: "Начало и регистрация",
      comboButtonActive: "Выбрано: {{count}}",
      comboAria: "Фильтр по началу мероприятия и регистрации",
      industryHeading: "Направление",
      industryAll: "Все направления",
      industrySelectedCount: "Выбрано: {{count}}",
      industryClear: "Сбросить",
      industryAria: "Фильтр по направлениям мероприятия",
    },
    searchLabel: "Поиск по мероприятиям",
    searchPlaceholder: "Поиск по названию или описанию…",
    statusFilterAria: "Фильтр по статусу мероприятия",
    statusAll: "Все",
    badges: {
      registration: "Регистрация",
      start: "Начало мероприятия",
    },
    myRegistrationChip: "Ваша заявка",
  },
  participantEventRegistration: {
    status: {
      0: "Зарегистрирован",
      1: "Отмечен на входе",
      2: "Выход с мероприятия",
      3: "Регистрация отменена",
      4: "Ожидает одобрения организатора",
      5: "Одобрено",
      6: "Заявка отклонена",
    },
  },
  eventDetail: {
    notFound: "Мероприятие не найдено",
    back: "Назад",
    allEvents: "Все мероприятия",
    about: "О мероприятии",
    loadError: "Не удалось загрузить мероприятие",
    participation: "Участие в мероприятии",
    date: "Дата",
    time: "Время",
    dateAndTime: "Дата и время проведения",
    place: "Место",
    registerNote: "Регистрация бесплатна. Количество мест ограничено.",
    share: "Поделиться",
    shareVk: "ВКонтакте",
    shareTg: "Telegram",
    shareCopy: "Скопировать ссылку",
    shareCopied: "Ссылка скопирована",
    galleryTitle: "Фотографии",
    galleryThumbAria: "Открыть фото {{index}} из {{total}}",
    galleryLightboxClose: "Закрыть просмотр",
    galleryLightboxPrev: "Предыдущее фото",
    galleryLightboxNext: "Следующее фото",
    related: "Другие мероприятия",
    noRelated: "Пока нет других мероприятий в афише",
    metaSection: "Детали и регистрация",
    direction: "Направление",
    registrationPeriod: "Период регистрации",
    locationRegion: "Город и страна",
    organizer: "Организатор",
    organizerEmail: "Email организатора",
    organizerPhone: "Телефон организатора",
    modalTitle: "Регистрация",
    registeredTitle: "Заявка принята!",
    registeredEmailHeadline: "Проверьте почту",
    registeredEmailBody:
      "На ваш email придёт письмо с подтверждением регистрации. Без этого шага регистрация не считается завершённой.",
    registeredEventLabel: "Мероприятие:",
    submitRegister: "Подтвердить регистрацию",
    registerSending: "Отправляем…",
    registerValidation: "Заполните все обязательные поля",
    registerFailed: "Не удалось зарегистрироваться",
    questionFallback: "Вопрос",
    selectPlaceholder: "Выберите вариант",
    multiSelectHint: "Отметьте один или несколько вариантов",
    noQuestionsHint: "Дополнительные вопросы при регистрации не заданы. Нажмите кнопку ниже, чтобы подтвердить участие.",
    alreadyRegisteredMessage:
      "Вы уже подали заявку на это мероприятие. Ниже в блоке «Участие» указан статус заявки. Повторная регистрация не требуется.",
    myRegistrationHeadline: "Ваша заявка",
    myRegistrationHint: "Статус заявки на участие",
    cancelRegistration: "Отменить регистрацию",
    cancelRegistrationHint: "После отмены вы сможете подать заявку снова, если регистрация ещё открыта.",
    cancelCannotAfterCheckIn: "Отмена недоступна после отметки на входе.",
    cancelConfirmTitle: "Отменить регистрацию?",
    cancelConfirmBody: "Вы уверены, что хотите отменить участие в этом мероприятии?",
    cancelConfirmAction: "Да, отменить",
    cancelConfirmAbort: "Нет, оставить",
    cancelSending: "Отменяем…",
    cancelFailed: "Не удалось отменить регистрацию",
    registrationCheckError: "Не удалось проверить статус заявки",
  },
}
